import { sheetServerRequest } from '../../apiRequests'

export const getCalculatedFields = async (inboxID) => {
    const action = {
        action: 'getCalculatedFields',
        sheetRange: {
            inboxID,
        },
    }
    return await sheetServerRequest(action)
}
